export interface SpriteThumbnail {
  start: number;
  end: number;
  url: string;
  x: number;
  y: number;
  w: number;
  h: number;
}

// example parser
export const parseWebVTT = (vtt: string): SpriteThumbnail[] => {
  const lines = vtt.trim().split("\n");
  const thumbnails: SpriteThumbnail[] = [];

  for (let i = 0; i < lines.length; i += 2) {
    const timeLine = lines[i];
    const urlLine = lines[i + 1];

    if (!timeLine.includes("-->") || !urlLine) continue;

    const [startStr, endStr] = timeLine.split(" --> ");
    const start = parseTimeToSeconds(startStr.trim());
    const end = parseTimeToSeconds(endStr.trim());

    const [baseUrl, coords] = urlLine.split("#xywh=");
    const [x, y, w, h] = coords.split(",").map(Number);

    thumbnails.push({
      start,
      end,
      url: baseUrl,
      x,
      y,
      w,
      h,
    });
  }

  return thumbnails;
};

const parseTimeToSeconds = (time: string): number => {
  const [h, m, s] = time.split(":").map(Number);
  return h * 3600 + m * 60 + s;
};
